<template>
  <div>
    <div class="avatar-uploader">
      <div v-if="value"
           style="position:relative">
        <img :src="value"
             class="avatar"/>
        <span class="el-upload-list__item-actions">
        <span class="el-upload-list__item-preview">
          <i class="el-icon-zoom-in"
             @click="view"/>
        </span>
        <span v-if="!disabled"
              class="el-upload-list__item-delete">
          <i class="el-icon-delete"
             @click="remove"/>
        </span>
      </span>
      </div>
      <el-upload
        action=""
        v-else
        class="el-uploader"
        :accept="accept"
        :disabled="disabled"
        :show-file-list="false"
        :http-request="sendRequest"
        :on-success="handleAvatarSuccess"
        :before-upload="beforeAvatarUpload">
        <i class="el-icon-plus avatar-uploader-icon"/>
        <div slot="tip"
             class="el-upload__tip">
          <span v-if="tip">{{ tip }}</span>
          <span v-else>
            请上传{{fileTypes}}文件，<span v-if="maxSize > 0">最大不得超过 {{maxSize}}MB，</span>仅支持上传1张图片
          </span>
        </div>
      </el-upload>
    </div>
  </div>
</template>

<script>
import ImageViewBox from '@/views/question-editor/components/image-view-box'

export default {
  props: {
    value: String,
    accept: {
      type: String,
      default: '.png,.jpeg,.jpg'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    request: {
      type: Function
    },
    maxSize: {
      type: Number,
      default: 1
    },
    tip: String
  },
  computed: {
    fileTypes () {
      return this.accept.replaceAll('.', '').replaceAll(',', '/').toUpperCase()
    }
  },
  methods: {
    /**
     * 触发事件"el.form.change"来对组件的值做一次验证，
     * 对应的父级form-item的rule的trigger需要设置为"change"
     */
    onChange () {
      this.$parent.$emit('el.form.change')
    },
    handleAvatarSuccess (res, file) {
      this.$emit('input', res.data)
      this.onChange()
    },
    sendRequest (options) {
      let form = new FormData()
      form.append('file', options.file)
      return this.request(form)
    },
    beforeAvatarUpload (file) {
      const sizeAllowed = !this.maxSize || file.size / 1024 / 1024 < this.maxSize

      if (!sizeAllowed) {
        this.$message.error(`上传图片大小不能超过 ${this.maxSize}MB!`)
      }

      return sizeAllowed
    },
    remove () {
      this.$emit('input', '')
      this.onChange()
    },
    view () {
      ImageViewBox.open([{src: this.value}], 0)
    }
  }
}
</script>

<style lang="scss"
       scoped>
$width: 178px;
$height: 178px;
.avatar-uploader {
  .el-uploader >>> .el-upload {
    cursor: pointer;
    border-radius: 6px;
    border: 1px dashed #d9d9d9;

    &:hover {
      border-color: #409EFF;
    }

    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: $width;
      height: $height;
      line-height: $height;
      text-align: center;
    }
  }

  .avatar {
    border-radius: 6px;
    border: 1px dashed #409EFF;
    position: relative;
    overflow: hidden;
    width: $width;
    height: $height;
    display: block;
  }

  .el-upload-list__item-actions {
    border-radius: 6px;
    position: absolute;
    width: $width;
    height: $height;
    left: 1px;
    top: 1px;
    cursor: pointer;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s;

    span {
      display: none;
      cursor: pointer;
    }

    span + span {
      margin-left: 15px
    }

    &:hover {
      opacity: 1;

      span {
        display: inline-block;
      }
    }

    &::after {
      display: inline-block;
      content: "";
      height: 100%;
      vertical-align: middle;
    }
  }

  .el-upload-list__item-delete {
    position: static;
    font-size: inherit;
    color: inherit;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AvatarUploader.vue